const AppMessages = {
  SupportEmail: "mailto:support@mana.ai",
  GuidesEmail: "mailto:guides@mana.ai",
  SyncInProgress: "Just a minute -- we’re updating your data now!",
  NotEnoughHours: `Hmm.. your week adds up to {TOTAL} hours but there are {AVAILABLE} hours. 
  Tap here for some options.`,
  TooManyHours: `Hmm.. your week adds up to {TOTAL} hours but there are only {AVAILABLE} hours. Tap here for some options.`,
  NotEnoughHoursRoutine: `Hmm.. your {TIME_INTERVAL} adds up to {TOTAL} hours but there are {AVAILABLE} hours. 
  Tap here for some options.`,
  TooManyHoursRoutine: `There are just {MAX} hours in a {TIME_INTERVAL}, so please remove hours from another Element if you need some more time.`,

  AutoTrackDone: "I’ve taken care of tracking while you were away!",
  AutoTrackHurray: "Hurray! You are back on track now!",
  AutoTrackReverted:
    "You can enter your data now. Or you can still use our suggestions",
  EditUncategorized:
    "Uncategorized time is automatically calculated when you fill in activity hours.",
  WelcomeToMana: `Mana works best when you schedule time to get onboarded with one of our expert coaches.`,
  SurveyCardTitle: `Let’s get to know each other.`,
  SurveyCardText: `Take a survey to help us get to know your time-style and reach out with personalized guidance.`,
  WelcomeToManaScheduled: `Great! You should have a meeting confirmation in your email inbox. For now, what about reading up on some of our methodologies?`,
  HomeCardMessage: `Each card here shows you the next steps to take towards leading a balanced life and reaching your goals.`,
  GuidanceCardText: `Tell us a bit more about yourself, so we can work on a plan just for you.`,
  AverageWeekCardText: `During your guide call, you’ll estimate where your time goes in an average week to be able to reflect on how you actually spend time after tracking. `,
  TrackCardText: `After your Guide call, here is where you’ll be able to track and see specifically where your time is spent.`,
  ReflectionCardText: `After your Guide call, here is where you’ll be able to reflect on how your time is spent, and see insights for how to spend your time better.`,
  GoalsCardText: `After your Guide call, here is where you’ll be able to set goals and monitor your progress in realtime!`,
  ElementsCardText: `After your Guide call, here is where you’ll manage the elements of your life that make up your time.`,
  TrackTutorialStep: [
    `Track your time often to have the most accurate insights!`,
    `Reflect on how you spend your time.`,
    `Get reminders on how you progress towards your goals.`,
    `Celebrate and reflect on your achievements!`,
  ],
  TrackRoutineEditModeInProgress:
    "Please finish editing by clearing timeslots or canceling to create and apply routines.",
  TrackBulkDateChangedWarning:
    "You can only edit one day at a time. Do you want to cancel current changes and switch days?",
  TrackATUSWarning:
    "Blue timeslots are autotracked based on averages from the American Time Use Survey. Set up more integrations for a view that is unique to you.",
  CoreElementTagIsRequired:
    "Please choose a core element that this activity belongs to. ",
  ParentElementIsRequired:
    "Please choose a parent element that this activity belongs to. ",
  CoreElementIsRequired:
    "Please choose a core element that this activity belongs to. ",
  IntegrationsDefaultUserMessage:
    "Integration not here? Tell us which app you’d like to integrate with Mana and we’ll get to work!",
  IntegrationsEarlyAccess:
    "Easter egg! We’re building this integration right now.",
  GoalDaysRequiredError:
    "Please choose at least one day when you plan to work towards this goal!",
  GoalValidationError: "Please fill in all the required fields!",
  CreateCoreElementMessage:
    "Creating an element without a parent will make it difficult to reflect on this element in meaningful categories.",
  TimeslotsOverrideWarning:
    "Watch out! If you confirm this, you'll replace already tracked entries",

  NoChildrenSelected:
    "This Element doesn’t have any children. Select Elements that are part of it above if you want to make this a “Major Element”",

  RoutineReplaceMessage:
    "We didn’t replace time you tracked with this routine. Do you want to?",
  EditRoutineNoResultsMessage:
    "Get started building a routine by adding the Elements that take up your time",
  RoutinesNoResultsMessage:
    "Save time by tracking with routines: similar sequences of activities, days, and weeks",
  AddElementsButtonText: "Add Elements",
  CreateDayRoutineButtonText: "Create Day Routine",
  CreateWeekRoutineButtonText: "Create Week Routine",
  RoutineIntegrationsOverrideMessage:
    "Your data shows that integrations have tracked this number of hours, are you sure you want to reduce?",
  RoutineUserTrackedOverrideMessage:
    "We didn’t replace time you tracked with this routine. Do you want to? ",
  RoutineUserTrackedOverrideButtonText: "Replace",
  RoutineApplyInProgress: "Just a minute -- we’re applying your routine now!",

  TrackMultipleErrorMessage:
    "Just 3 at a time, please! Remove a selected Element to add another.",
  CustomizeElementsTeamSummary:
    "Time tracked on these team Elements is what you’ll be reporting. Add more specific Elements to the existing categories so you can prioritize more effectively.",
  CustomizeElementsPersonSummary:
    "Add more specific Elements to the existing categories so you can prioritize more effectively.",
  CustomizeElementsPersonLifeElementsSummary:
    "Think about what activities you want to spend more or less time on and add them here.",

  NewGoalDescription:
    "Improving how you spend your time starts with mindfulness. Once you understand where the time goes, then you can take action and make change.",
  NewGoalHow:
    "Commit to trying out Mana for a week and writing at least one journal entry.",
  EmptyReflectionPageMariMessage:
    "Check back soon! Once you’ve tracked a full day, week, month, or year, you can submit a report.",
  EmptyTrackPageMariMessage:
    "Once you’ve tracked a full day, you can save it as a routine and use it to track other days quickly!",
  NoCalendarsNotificationsTitle: "We can’t track your calendar events!",
  NoCalendarsNotificationsMessage:
  "You connected an account for autotracking, but we need you to choose which calendars to autotrack. Tap to configure - it just takes a sec!",
  ReportMarkedAsUnread: "Report marked as unread!",
};

export default AppMessages;
